import styled from 'styled-components';
import '../../../../log2base2.css';

export const FocusContainer = styled.div`
  width: var(--layoutWidth);
  max-width: var(--layoutMaxWidth);
  margin: 0 auto;
  padding: 30px 20px 20px 20px;
  text-align: center;
  @media (min-width: 992px) {
    padding: 30px 0px 20px 0px;
  }
`;

export const FeatureContainerTitle = styled.h2`
  font-weight: 600 !important;
  padding-bottom: 25px;
  display: inline-block;
  background: linear-gradient(90deg, var(--gradientPrimaryColor), var(--gradientSecondaryColor));
  -ms-background-clip: text;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const FeatureContainerTitleText = styled.h2`
  font-weight: 600 !important;
  padding-bottom: 25px;
  display: inline-block;
  color: ${({ variant }) =>
    variant === 'partner-plus'
      ? 'var(--partnerPlusColor)'
      : variant === 'regionals'
      ? 'var(--regionalsDark)'
      : variant === 'code-juniors'
      ? 'var(--codeJuniorsColor)'
      : 'var(--brandColor)'};
`;

export const FeatureContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px 0px;
  @media (min-width: 576px) {
    padding: 10px 20px;
  }
  @media (min-width: 992px) {
    flex-direction: row;
    padding: 10px;
  }
`;

export const ReverseFeatureContainer = styled(FeatureContainer)`
  @media (max-width: 991px) {
    flex-direction: column-reverse;
  }
`;

export const FeatureContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (min-width: 992px) {
    width: 50%;
  }
`;

export const FeatureTitle = styled.h2`
  text-align: left;
  max-width: 30rem;
  padding-bottom: 20px;
  color: var(--inputTxtColor);
  @media (min-width: 992px) {
    max-width: 22rem;
    margin-left: ${(props) => props.marginLeft && 'auto'};
  }
  @media (min-width: 1200px) {
    max-width: 23rem;
  }
  @media (min-width: 1400px) {
    max-width: 28rem;
    padding-bottom: 25px;
  }
  @media (min-width: 2000px) {
    max-width: 32rem;
  }
`;

export const FeatureSubTitle = styled.h4`
  text-align: left;
  width: 100%;
  max-width: 30rem;
  color: #0e101a;
  padding-bottom: 15px;
  font-size: 12px !important;
  letter-spacing: 0.25px;
  @media (min-width: 768px) {
    font-size: 14px !important;
  }
  @media (min-width: 992px) {
    max-width: 22rem;
    margin-left: ${(props) => props.marginLeft && 'auto'};
  }
  @media (min-width: 1200px) {
    max-width: 23rem;
  }
  @media (min-width: 1400px) {
    max-width: 28rem;
    padding-bottom: 20px;
  }
  @media (min-width: 2000px) {
    font-size: 15px !important;
    max-width: 32rem;
  }
`;

export const FeatureDescription = styled.p`
  text-align: left;
  max-width: 30rem;
  color: var(--darkGreyTxtColor);
  font-size: 15px;
  @media (min-width: 992px) {
    font-size: 16px;
    max-width: 22rem;
    margin-left: ${(props) => props.marginLeft && 'auto'};
  }
  @media (min-width: 1200px) {
    max-width: 23rem;
  }
  @media (min-width: 1400px) {
    font-size: 18px;
    max-width: 28rem;
  }
  @media (min-width: 2000px) {
    max-width: 32rem;
  }
`;

export const FeatureAnimation = styled.div`
  width: 100%;
  max-width: 600px;
  padding: 20px 0;
  margin: 0px auto;
  @media (min-width: 992px) {
    width: 50%;
    padding: 0px;
  }
`;

export const Video = styled.video`
    width: 100% !important;
    align-self: center;
    margin: 10px auto;
    @media (max-width: 800px) {
        margin-top: 0;
    }
    animation: fadeIn ease 3s;
    -webkit-animation: fadeIn ease 3s;
    -moz-animation: fadeIn ease 3s;
    -o-animation: fadeIn ease 3s;
    -ms-animation: fadeIn ease 3s;

    @keyframes fadeIn {
        0% {
            opacity:0;
            }
        100% {
            opacity:1;
            }
    }
    @-moz-keyframes fadeIn {
        0% {
            opacity:0;
        }
        100% {
            opacity:1;
        }
    }
    @-webkit-keyframes fadeIn {
        0% {
            opacity:0;
        }
        100% {
            opacity:1;
        }
    }    
    @-o-keyframes fadeIn {
        0% {
            opacity:0;
        }
        100% {
            opacity:1;
        }
    }    
    @-ms-keyframes fadeIn {
        0% {
            opacity:0;
        }
        100% {
            opacity:1;
    }
`;
